const ACTIONS = {
    BOOKING_SUBMIT: 'BOOKING_SUBMIT'
};

const ACTION_CREATORS = {
    requestToBookModalSubmit() {
        return {
            type: ACTIONS.BOOKING_SUBMIT,
            payload: {}
        };
    }
};

export default {...ACTIONS, ...ACTION_CREATORS};
